module.exports = __webpack_public_path__ + "static/media/king_heart.558e7f7d.png";